export default [
  {
    permissions: ['SM', 'CM', 'EM'],
    title: 'ZLR Valeon Mentor Agreement.pdf',
    // 这里url要改成接口获得,这个会作为默认值
    url:
      'https://res.zailairen.com/msp/docs/mentor/ZLR%20Valeon%20Mentor%20Agreement.pdf'
  },
  {
    permissions: ['EM'],
    title: 'Graduate EM Guide V.2.pdf',
    url:
      'https://res.zailairen.com/msp/docs/mentor/em/2020/Graduate%20EM%20Guide%20V.2.pdf'
  },
  {
    permissions: ['EM'],
    title: 'EM - CV Templates.pdf',
    url:
      'https://res.zailairen.com/msp/docs/mentor/em/EM%20-%20CV%20Templates.pdf'
  },
  {
    permissions: ['EM'],
    title: 'EM - Case Study CVs.pdf',
    url:
      'https://res.zailairen.com/msp/docs/mentor/em/EM%20-%20Case%20Study%20CVs.pdf',
    attachments: [
      {
        permissions: ['EM'],
        title: 'EM - Case Study CVs.docx',
        url:
          'https://res.zailairen.com/msp/docs/mentor/em/EM%20-%20Case%20Study%20CVs.docx'
      }
    ]
  },
  {
    permissions: ['SM', 'CM'],
    title: 'Graduate SMCM Complete Guide V.2.pdf',
    url:
      'https://res.zailairen.com/msp/docs/mentor/sm/2020/Graduate%20SMCM%20Complete%20Guide%20V.2.pdf'
  },
  {
    permissions: ['SM', 'CM'],
    title: 'SMCM Highlights Guide V.2.pdf',
    url:
      'https://res.zailairen.com/msp/docs/mentor/sm/2020/SMCM%20Highlights%20Guide%20V.2.pdf'
  },
  {
    permissions: ['SM', 'CM'],
    title: 'SMCM Essay Guide V.2.pdf',
    url:
      'https://res.zailairen.com/msp/docs/mentor/sm/2020/SMCM%20Essay%20Guide%20V.2.pdf'
  },
  {
    permissions: ['SM', 'CM', 'EM'],
    title: 'Zoom add-on Instruction.pdf',
    url:
      'https://res.zailairen.com/msp/docs/mentor/sm/2020/Zoom%20add-on%20Instruction.pdf'
  },
  {
    permissions: ['SM', 'CM', 'EM'],
    title: 'MSP V4.0 User Manual.pdf',
    url:
      'https://res.zailairen.com/msp/docs/mentor/MSP%20V4.0%20User%20Manual.pdf'
  }
]
